import { Navigate, useRouterState } from '@tanstack/react-router'
import { useTypedSelector } from 'hooks/useTypedSelector'

import { RequireAuthProps } from './types'

export const RequireAuth = ({ children }: RequireAuthProps) => {
  const { token, inLoading } = useTypedSelector((state) => state.authReducer)
  const {
    location: { pathname }
  } = useRouterState()

  if (token || inLoading) {
    return children
  }

  return (
    <Navigate
      to="/auth"
      params={{
        redirectTo: pathname
      }}
    />
  )
}
